import { Box, Hidden, makeStyles, Typography } from "@material-ui/core";
import classnames from "classnames";
import HomeRepairZoneNotServed from "components/design-system/molecules/HomeRepairZoneNotServed";
import UnAvailableTimeSlotInfo from "components/design-system/organisms/UnAvailableTimeSlotInfo";
import ReassuranceItems from "components/HomeRepairFunnelV2/DateSelection/ReassuranceItems";
import { MURFY_ZENDESK_LINK_P2 } from "lib/constants";
import * as React from "react";
import { Grid } from "ui/grid/Grid";
import { RepairFunnelFooter } from "../repairFunnel/steps/repairFunnelMalfunctionStep/RepairFunnelFooter";
import { DesktopCalendar } from "./DesktopCalendar";
import { MobileCalendar } from "./MobileCalendar";

export const Calendar = (props) => {
  const {
    data,
    handleNextStep,
    handlePreviousStep,
    headingText,
    nextInterventionPlanning,
    setTimeslot,
    shouldDisableContinueButton,
    selectedTimeslot,
    repairPackagePrice,
    checkItems,
    checkItemsTitle,
    displayCancelInfo,
    displayPaymentInfo,
    timeslotText,
    noZone,
    productType,
    postalCode,
  } = props;
  const classes = useStyles();
  const noData = React.useMemo(
    () => !noZone && data && data.timeslots?.length === 0 && !data.next_timeslot,
    [data, noZone]
  );

  if (noZone) {
    return <HomeRepairZoneNotServed productType={productType} postalCode={postalCode} />;
  }

  if (noData) {
    return <UnAvailableTimeSlotInfo href={nextInterventionPlanning && MURFY_ZENDESK_LINK_P2} />;
  }

  return (
    <Grid container>
      {headingText && (
        <Grid item xs={12}>
          <Box pt={2.5} pr={2.5} pl={2.5}>
            <Typography
              color="secondary"
              variant="h2"
              className={classnames({ [classes.header]: !nextInterventionPlanning })}
            >
              {headingText}
            </Typography>
          </Box>
        </Grid>
      )}
      <Grid item xs={12} container spacing={nextInterventionPlanning ? 2 : 5} className={classes.container2}>
        <Grid item xs={12} md={nextInterventionPlanning ? 12 : 8}>
          <Hidden mdUp>
            <MobileCalendar {...props} data={data} setTimeslot={setTimeslot} selectedTimeslot={selectedTimeslot} />
          </Hidden>
          <Hidden smDown>
            <DesktopCalendar {...props} data={data} setTimeslot={setTimeslot} selectedTimeslot={selectedTimeslot} />
          </Hidden>
          {/* TODO: Single Responsibility : remove form controls & reassurance items from Calendar component */}
          <RepairFunnelFooter
            gotoPreviousStep={handlePreviousStep}
            gotoNextStep={handleNextStep}
            shouldHideNext={!handleNextStep}
            shouldDisableContinueButton={shouldDisableContinueButton}
          />
        </Grid>
        {checkItems && (
          <ReassuranceItems
            checkItemsTitle={checkItemsTitle}
            checkItems={checkItems}
            displayCancelInfo={displayCancelInfo}
            displayPaymentInfo={displayPaymentInfo}
            timeslotText={timeslotText}
            repairPackagePrice={repairPackagePrice}
          />
        )}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "inherit",
  },
  container2: {
    maxWidth: "inherit",
    marginTop: -theme.spacing(2),
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  box: {
    [theme.breakpoints.up("sm")]: {
      whiteSpace: "nowrap",
    },
  },
  info: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(0),
      textAlign: "center",
    },
  },
}));
